// Legend row — shared between the single + all modes.
export function AvailabilityLegend({ tierColors }) {
  const items = [
    ['green',  'Healthy'],
    ['yellow', 'Monitor'],
    ['orange', 'At risk'],
    ['red',    'Critical'],
    ['gray',   'Closed / no target'],
  ];
  return (
    <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
      {items.map(([t, label]) => (
        <span key={t} style={{ display: 'inline-flex', gap: 5, alignItems: 'center', fontSize: 10, color: '#5a6470' }}>
          <span style={{ width: 10, height: 10, borderRadius: 2, background: tierColors[t]?.stripe || '#9e9e9e', display: 'inline-block' }} />
          {label}
        </span>
      ))}
      {/* CJ 2026-07-29: the per-day 🌴 / N/M badges had no key. */}
      <span style={{ display: 'inline-flex', gap: 4, alignItems: 'center', fontSize: 10, color: '#5a6470' }}>
        <span style={{ fontSize: 10, fontWeight: 700, color: '#8a5a1f', background: '#fff3e0', borderRadius: 3, padding: '0 3px' }}>🌴N</span>
        on time off
      </span>
      <span style={{ display: 'inline-flex', gap: 4, alignItems: 'center', fontSize: 10, color: '#5a6470' }}>
        <span style={{ fontSize: 10, fontWeight: 700, color: '#2e7d32' }}>N/M</span>
        available at thinnest hour / staff needed
      </span>
    </div>
  );
}
